import React from "react";
import VestingReductionReportContainer from "../../../containers/ReportsContainer/VestingReductionReportContainer";

const VestingReductionReport = (props) => {
  return <VestingReductionReportContainer {...props} />;
};

export default VestingReductionReport;
